var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { getIcon, FlightOverflowMenu, FlightSelect } from '@flybits/design-system';
import { retrievePlugins, retrieveSelectedPlugin, getConstraints } from '../../utils/helpers';
var isFullFrame = function (props) {
    return props.headerProps !== undefined;
};
var FullFrame = function (props) {
    var _a, _b;
    var children = props.children, renderProps = props.renderProps;
    var isLastBlock = renderProps.isLastBlock, isExpanded = renderProps.isExpanded, headerProps = renderProps.headerProps;
    var DEFAULT_CLASS = 'rule-frame';
    var uiBlock = headerProps.uiBlock, handleExpandToggle = headerProps.handleExpandToggle, removePredicate = headerProps.removePredicate, contextPlugins = headerProps.contextPlugins, addPredicate = headerProps.addPredicate, displayId = headerProps.displayId;
    var isDeleteLocked = getConstraints(uiBlock).isDeleteLocked;
    var FIELD_WIDTH = '470px';
    var pluginsList = retrievePlugins(contextPlugins, uiBlock);
    var arrowUpIcon = getIcon('baselineKeyboardArrowUp', {});
    var arrowDownIcon = getIcon('baselineKeyboardArrowDown', {});
    var mapToDropdownItems = function (uiBlock, pluginsList) {
        if ((uiBlock.categoryDisplayName || uiBlock.category) && (uiBlock.attributeDisplayName || uiBlock.attributeName)) {
            return pluginsList.find(function (option) { return option.key === uiBlock.ctxAttributeUid; }) || null;
        }
        else {
            return null;
        }
    };
    var _c = __read(useState(mapToDropdownItems(uiBlock, pluginsList)), 2), selectedPlugin = _c[0], setSelectedPlugin = _c[1];
    var nodeId = uiBlock.nodeId;
    var selectPluginAndRenderRuleBlock = function (option, uiBlock) {
        setSelectedPlugin(option);
        var ctxPlugin = retrieveSelectedPlugin(option.key, contextPlugins);
        if (ctxPlugin && addPredicate)
            addPredicate(ctxPlugin, option.value, nodeId, uiBlock);
    };
    return (React.createElement("div", { className: "".concat(DEFAULT_CLASS).concat(isLastBlock ? ' last-block' : '') },
        React.createElement("div", { className: "".concat(DEFAULT_CLASS, "__ruleInfo") },
            React.createElement("div", { className: "".concat(DEFAULT_CLASS, "__title") },
                React.createElement("span", { className: "".concat(DEFAULT_CLASS, "__title__nodeId") }, displayId)),
            React.createElement("div", { className: "".concat(DEFAULT_CLASS, "__icon").concat(uiBlock.iconUrl ? '' : " ".concat(DEFAULT_CLASS, "__icon--blank")) }, uiBlock.iconUrl ? React.createElement("img", { src: uiBlock.iconUrl, alt: "Rule Icon" }) : getIcon('infoFilled', {})),
            React.createElement("div", { className: "".concat(DEFAULT_CLASS, "__body").concat(uiBlock.isExpanded ? '--expanded' : '') },
                ((_a = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.hasPlaceHolder) === null || _a === void 0 ? void 0 : _a.name) || ((_b = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.hasPlaceHolder) === null || _b === void 0 ? void 0 : _b.contextOrHistorical) ? (React.createElement(FlightSelect, { className: "".concat(DEFAULT_CLASS, "__ruleDropdown"), options: pluginsList, selected: selectedPlugin, handleOptionClick: function (option) {
                        selectPluginAndRenderRuleBlock(option, uiBlock);
                    }, width: FIELD_WIDTH })) : (React.createElement("span", { className: "".concat(DEFAULT_CLASS, "__ruleName") },
                    uiBlock.categoryDisplayName || uiBlock.category,
                    " /",
                    ' ',
                    React.createElement("b", null, uiBlock.attributeDisplayName || uiBlock.attributeName))),
                isExpanded && children)),
        React.createElement("div", { className: "".concat(DEFAULT_CLASS, "__toggles") },
            React.createElement(FlightOverflowMenu, { className: "".concat(DEFAULT_CLASS, "__toggleItem"), direction: 'bottom', isOpenRight: false, disabled: isDeleteLocked, optionGroups: [
                    [
                        {
                            key: 1,
                            name: 'Delete',
                            disabled: false,
                            onClick: function () { return removePredicate(nodeId); },
                        },
                    ],
                ] }),
            React.createElement("button", { className: "".concat(DEFAULT_CLASS, "__toggleItem"), onClick: function () { return handleExpandToggle(uiBlock.nodeId); } }, uiBlock.isExpanded ? arrowUpIcon : arrowDownIcon))));
};
var CustomFrame = function (props) {
    var children = props.children, renderProps = props.renderProps;
    var isLastBlock = renderProps.isLastBlock, isExpanded = renderProps.isExpanded;
    var DEFAULT_CLASS = 'rule-frame';
    return React.createElement("div", { className: "".concat(DEFAULT_CLASS).concat(isLastBlock ? ' last-block' : '') }, isExpanded && children);
};
var RuleFrame = function (props) {
    return isFullFrame(props.renderProps) ? (React.createElement(FullFrame, { renderProps: props.renderProps }, props.children)) : (React.createElement(CustomFrame, { renderProps: props.renderProps }, props.children));
};
export default RuleFrame;
//# sourceMappingURL=RuleFrame.js.map